<template>
	<div style="padding: 10px; background-color: #fff;margin: 10px;border-radius: 3px;min-height: 97%;">


		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--搜索start-->
			<div>
				<el-form size="mini" style="padding-left: 20px;display: flex;flex-wrap: wrap;" :style="{'height':'50px'}" ref="searchForm" :model="searchForm" inline  :label-width="isMobile?'200px':'120px'">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div style="width: 80%;display: flex;">

						<el-form-item label="门店状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.status" clearable placeholder="请选择">
								<el-option label="全部" :value="0" />
								<el-option label="正常" :value="1" />
								<el-option label="关闭" :value="2" />
							</el-select>
						</el-form-item>

					</div>
					<!--收起时显示的搜索项end-->

					<div :style="{'width':'13%','justify-content': 'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>

					</div>


				</el-form>
			</div>
			<!--搜索end-->

			<!-- <div style="display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;margin-left: 5px;">

				<div style="margin-right: 20px;margin-left: 35px;">
					<el-button @click="showAddPop" type="primary" round icon="el-icon-plus" size="mini">添加</el-button>
				</div>
			</div> -->
		</div>


		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;margin-left: 20px;">
						<div class="avatar">

							<!--用户图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.image" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.image)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--用户图片end-->

							<div style="width: 180px;">

								<!--头像右侧一个列表项start-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								<!--头像右侧一个列表项end-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">名称：</span>
									<el-tooltip :content="row.name" placement="right">
										<div class="dian dianL">{{row.name}}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">电话：</span>
									<el-tooltip :content="row.mobile+''" placement="right">
										<div class="dian dianL">{{row.mobile}}</div>
									</el-tooltip>
								</div>



								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">状态：</span>
									<el-tooltip :content="row.deleted_at?'关闭':'正常'" placement="right">
										<div v-if="row.deleted_at" class="dian dianL" style="color: red;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
											<div style="width: 10px;height: 10px;background-color: red;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
											已关闭
										</div>
										<div v-else class="dian dianL" style="color: rgb(103, 194, 58);font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
											<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
											正常
										</div>
										
									</el-tooltip>
								</div>



							</div>
						</div>

						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">
							<!-- 一个方块列表项start-->
							<li>
								<div class="content">
									<div v-if="row.is_direct==0" class="dian">否</div>
									<div v-if="row.is_direct==1" class="dian">是</div>

								</div>
								<div class="titleFont">是否直营</div>
							</li>
							<!-- 一个方块列表项end-->

							<li style="width: 200px;">
								<div class="content" style="width: 180px;">
									<el-tooltip :content="row.address?row.address:'无'" placement="right" style="width: 180px;">
										<div class="dian" style="width: 180px;">{{row.address?row.address:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">地址</div>
							</li>


							<li>
								<el-tooltip :content="row.business_hours+''" placement="right">

									<div class="content dis">
										{{row.business_hours}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">营业时间</div>
							</li>
							
							<li>
								<el-tooltip :content="row.contract_extension+'天'" placement="right">
							
									<div class="content dis">
										{{row.contract_extension+'天'}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">合同延期</div>
							</li>
							
							<li>
								<el-tooltip :content="row.notice_mobile?row.notice_mobile+'':'无'" placement="right">
							
									<div class="content dis">
										{{row.notice_mobile?row.notice_mobile:'无'}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">接收通知手机号</div>
							</li>
							
							
					
							
							<li style="width: 100px;">
								<div class="content" style="width: 90px;">
									<el-tooltip :content="row.user?row.user.nickname+'':'无'" placement="right" style="width: 90px;">
										<div class="dian" style="width: 90px;">{{row.user?row.user.nickname+'':'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">关联用户昵称</div>
							</li>
							
							<li >
								<div class="content" style="height:25px;">
									<img v-if="row.user" :src="row.user.avatar" style="width:35px;height:25px; cursor: pointer;border-radius: 5px;" @click="handlePreView(row.user.avatar)">
									<div v-else>无</div>
								</div>
								<div class="titleFont dian">关联用户头像</div>
							</li>
							
							<li>
								<el-tooltip :content="row.user?row.user.mobile+'':'无'" placement="right">
							
									<div class="content dis">
										{{row.user?row.user.mobile:'无'}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">关联用户手机号</div>
							</li>
							
							
							
							
							

							<li>
								<el-tooltip :content="row.created_at+''" placement="right">

									<div class="content dis">
										{{row.created_at | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">创建时间</div>
							</li>

							<li>
								<el-tooltip :content="row.updated_at+''" placement="right">

									<div class="content dis">
										{{row.updated_at | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">更新时间</div>
							</li>
							
						
							
							

						</ul>


						<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showAddPop(row)">编辑
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-if="row.deleted_at">
										<el-button type="danger" size="mini" round @click="huiFu(row)">恢复
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-else>
										<el-button type="danger" size="mini" round @click="del(row)">关闭
										</el-button>
									</el-dropdown-item>


								</el-dropdown-menu>
							</el-dropdown>

						</div>

					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->
		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->



		<!-- 添加或编辑弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" ref="form" custom-class="m-dialog" title="信息" center :visible.sync="isShowAddPop">
			<div v-if="isShowAddPop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 60px;" label-width="120px" size="small" ref="form" :rules="formRules" :model="form">

						<el-form-item label="是否直营" prop="is_direct">
							<el-select v-model="form.is_direct" clearable placeholder="请选择" style="width: 250px;">
								<el-option label="是" :value="1" />
								<el-option label="否" :value="0" />
							</el-select>
						</el-form-item>

						<el-form-item label="名称" prop="name">
							<el-input style="width: 250px;" v-model="form.name" placeholder="请输入名称"></el-input>
						</el-form-item>

						<el-form-item label="图片" prop="image" style="position: relative;">
							<div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">680*910</div>
							<upload-img :imgWidth="680" :imgHeight="300" :limit='1' accept="image/png" fileAfterName=".png" ref="fengMianUpload" :imgList="form.image"></upload-img>

						</el-form-item>

						<el-form-item label="地址" prop="address">
							<el-input style="width: 250px;" v-model="form.address" placeholder="请输入地址"></el-input>
						</el-form-item>

						<el-form-item label="营业时间" prop="business_hours">

							<div style="display: flex;align-items: center;">

								<el-time-select style="width: 108px;" placeholder="起始时间" v-model="startTime" :picker-options="{
							      start: '00:00',
							      step: '00:30',
							      end: '24:00'
							    }">
								</el-time-select>
								<div style="margin-left: 10px;margin-right: 10px;color: #aaa;">－</div>
								<el-time-select style="width: 108px;" placeholder="结束时间" v-model="endTime" :picker-options="{
							      start: '00:00',
							      step: '00:30',
							      end: '24:00',
							      minTime: startTime
							    }">
								</el-time-select>
							</div>

						</el-form-item>


						<el-form-item label="电话" prop="mobile">
						
							<el-input style="width: 250px;"  v-model="form.mobile" placeholder="请输入电话"></el-input>
						</el-form-item>

						<el-form-item label="合同延期 (天)" prop="contract_extension">
							<el-input style="width: 250px;" type="number" v-model="form.contract_extension" placeholder="请输入合同延期 (天)"></el-input>
						</el-form-item>
						
						<el-form-item label="接收通知手机号" >
						
							<el-input style="width: 250px;"  v-model="form.notice_mobile" placeholder="请输入接收通知手机号"></el-input>
						</el-form-item>
						
						<el-form-item label="关联用户手机号" >
						
							<el-input style="width: 250px;"  v-model="form.user_mobile" placeholder="请输入关联用户手机号"></el-input>
						</el-form-item>
						


					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="save('form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加或编辑弹窗end -->


		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	import uploadImg from '../../components/upload/uploadImg.vue'
	export default {
		name: 'store',
		components: {
			uploadImg
		},
		data() {
			return {
				mobileWidth:window.mobileWidth-10,
				isMobile:window.isMobile,
				isShowAddPop: false, //是否显示首页添加轮播图弹窗
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址
				tableHeight: 0, //表格高度
				loading: false,

				startTime: '',
				endTime: '',

				tabName: '首页轮播图', //tab默认选中项
				searchForm: {}, //首页轮播图的搜索
				tableData: [], //首页轮播图的表格数据

				isShowCollapse: false, //是否展开搜索
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				form: {
					store_id: '',
					name: '',
					image: [],
					address: '',
					business_hours: '',
					mobile: '',
					user_mobile:'',
					notice_mobile:'',
					contract_extension: 0,
					is_direct: ''
				},
				formRules: {

					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					is_direct: [{

						required: true,
						message: '请选择是否直营',
						trigger: 'change'
					}],
					business_hours: [{

						required: true,
						message: '请选择营业时间',
						trigger: 'submit'
					}],
					image: [{
						type: 'array',
						required: true,
						message: '请选择上传图片',
						trigger: 'change'
					}],
					mobile: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur',

					}],
					contract_extension: [{
						required: true,
						message: '请输入合同延期',
						trigger: 'blur',
					
					}],



				},




			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},

		mounted() {

			this.initData();
		},

		created() {
			this.getTableHeight();
		},
		mounted() {

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};


			this.initData();
		},

		methods: {

			//初始化表格数据
			async initData() {

				this.loading = true
				let param = {
					count: this.pageSize,
					page: this.pageNumber
				};
				if (this.searchForm.status) {
					param.status = this.searchForm.status;
				}
				console.log('param==>', this.searchForm.status)
				let ress = await ajax('/hq/store', 'GET', param);
				this.loading = false;
				let res = ress.data.data;
				this.total = res.total;
				this.tableData = res.store;
			},

			//删除
			async del(row) {
				this.$confirm('确定要关闭吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/store', 'DELETE', {
						store_id: row.id,
						status: 0
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.initData();
				});
			},


			//恢复
			async huiFu(row) {
				this.$confirm('确定要恢复正常吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/store', 'DELETE', {
						store_id: row.id,
						status: 1
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.initData();
				});
			},





			//翻页
			changePage(pageNumber) {
				console.log('即将翻到' + pageNumber + '页')

				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},



			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 220; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//点击添加或编辑按钮
			showAddPop(row) {
				
				this.form = {
					store_id: '',
					name: '',
					image: [],
					address: '',
					business_hours: '',
					mobile: '',
					user_mobile:'',
					notice_mobile:'',
					contract_extension:0,
					is_direct: ''
				};
				this.startTime='';
				this.endTime='';
				
				
				
				console.log(row)
				if (row.id) { //编辑
					console.log('row===>', row)
					this.form.store_id = row.id;
					this.form.name = row.name;
					this.form.image = [{
						url: row.image
					}];
					this.form.address = row.address;
					this.form.business_hours = '';
					this.startTime = row.business_hours.split('-')[0];
					this.endTime = row.business_hours.split('-')[1];
					this.form.mobile = row.mobile;
					this.form.notice_mobile = row.notice_mobile?row.notice_mobile:'';
					this.form.user_mobile = row.user?row.user.mobile:'';
					
					this.form.contract_extension = row.contract_extension;
					this.form.is_direct = row.is_direct;
				}
				this.isShowAddPop = true;
			},
			//浏览图片
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},

			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},
			//首页轮不同的重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()

			},

			//首页轮播图添加或编辑的保存
			async save(formName) {
				if(!this.startTime){
					this.$message.error('请选择开始营业时间');
					return
				}
				if(!this.endTime){
					this.$message.error('请选择结束营业时间');
					return
				}
				this.form.business_hours = this.startTime+'-'+this.endTime;
				this.form.image = this.$refs.fengMianUpload.getImgList(); //商品封面图
				this.$refs[formName].validate(async (valid) => {
					if (valid) {



						let method = "POST";
						if (this.form.store_id) {
							method = 'PUT'
						}
						this.loading = true;
						let ress = await ajax('/hq/store', method, {
							store_id: this.form.store_id,
							name: this.form.name,
							image: this.form.image[0].url,
							address: this.form.address,
							business_hours: this.form.business_hours,
							mobile: this.form.mobile,
							notice_mobile: this.form.notice_mobile?this.form.notice_mobile:undefined,
							user_mobile: this.form.user_mobile?this.form.user_mobile:undefined,
							
							contract_extension:this.form.contract_extension,
							is_direct: this.form.is_direct


						});
						
						this.loading = false;

						this.$refs[formName].resetFields();
						this.form = {
							store_id: '',
							name: '',
							image: [],
							address: '',
							business_hours: '',
							mobile: '',
							user_mobile:'',
							notice_mobile:'',
							contract_extension:0,
							is_direct: ''
						};
						this.startTime='';
						this.endTime='';
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddPop = false;
						this.initData();

					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});



			},







		}



	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
